import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Typography } from "@/shared/ui/atoms";
interface TreatmentCaseSummaryCardProps {
  index: number;
  treatmentCaseId: number;
  treatmentSubjectName: string;
  title: string;
  thumbnail: {
    afterImageUrl: string;
  };
  href: string;
}
const TreatmentCaseSummaryCard = t0 => {
  const $ = _c(16);
  const {
    index,
    treatmentSubjectName,
    title,
    thumbnail,
    href
  } = t0;
  let t1;
  if ($[0] !== thumbnail.afterImageUrl) {
    t1 = thumbnail.afterImageUrl?.trim();
    $[0] = thumbnail.afterImageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const afterImageUrl = t1;
  let t2;
  if ($[2] !== afterImageUrl || $[3] !== index) {
    t2 = <div className="flex-shrink-0 relative w-[98px] h-[98px] rounded-lg flex items-center justify-center overflow-hidden">{afterImageUrl ? <Image src={afterImageUrl} alt={"\uCE58\uB8CC \uC0AC\uB840"} fill={true} sizes="98px" className="object-cover rounded-xlg relative" priority={index === 0} /> : <div className="h-full w-full bg-gray-100" aria-hidden={true} />}</div>;
    $[2] = afterImageUrl;
    $[3] = index;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== treatmentSubjectName) {
    t3 = <Typography size={12} lineHeight={14} className="mb-[6px] px-2 py-1 w-fit border border-gray-200 rounded-full text-gray-500 font-medium">{treatmentSubjectName}</Typography>;
    $[5] = treatmentSubjectName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== title) {
    t4 = <Typography size={16} lineHeight={20} className=" text-gray-800 font-semibold line-clamp-2">{title}{" "}</Typography>;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="px-4 pt-3 pb-[14px]">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== href || $[13] !== t2 || $[14] !== t5) {
    t6 = <Link href={href} className="flex rounded-xl bg-white">{t2}{t5}</Link>;
    $[12] = href;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default TreatmentCaseSummaryCard;